// REACT_APP_API_TARGET=dev pins Netlify PR previews to dev.api; REACT_APP_API_URL
// points any other non-production build (staging, feature previews) at its API.
// Emulator builds (REACT_APP_USE_EMULATOR=true) only ever talk to their own
// API: locally http://localhost:8000, otherwise exactly REACT_APP_API_URL
// (see utils/emulatorTransport.ts).
import { apiBaseUrlFor, emulatorPlan } from 'utils/emulatorTransport';

export const apiBaseUrl = apiBaseUrlFor(
  process.env,
  emulatorPlan(process.env, document.location.origin),
  document.location.host
);

export const apiWebSocketBaseUrl = apiBaseUrl.replace(/^http/, 'ws');
